import layout from '@pc/views/home/components/layout/index.vue'
import G_RULE_DYNAMIC_API from '@pc/api/home/rule_dynamic.js'

export default {
	data () {
		return {
			code: this.$route.query.code || '', // 合同编号
			scene: this.$route.query.scene || '', // 场景
			title: '', // 标题
			pubTime: '', // 发布时间
			body: '' // 规则详情
		}
	},
	components: {
		layout
	},
	methods: {
		// 逻辑入口
		init () {
			// 查询规则详情
			this.queryRuleDetail()
		},

		// 查询规则详情
		queryRuleDetail () {
			// 若无合同编号，返回列表页
			if (!this.code || !this.scene) {
				this.$router.push('/rule_dynamic_list')
				return;
			}

			G_RULE_DYNAMIC_API.getRuleDynamicsDetail({
				scene: this.scene,
				template_code: this.code
			}).then(res => {
				if (+res.retcode === 0) {
				let {result_rows: {body, pub_time, title} = {}} = res

				// 规则详情赋值
				this.title = title || ''
				this.pubTime = pub_time || ''
				this.body = body || ''
				}
			})
			.catch(err => {
				this.$message.error(err);
			})
		}
	},
    mounted () {
        this.init()
    }
}